import { render, staticRenderFns } from "./ServiceCentreCollapse.vue?vue&type=template&id=6a94d188&"
import script from "./ServiceCentreCollapse.vue?vue&type=script&lang=js&"
export * from "./ServiceCentreCollapse.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCentreCollapse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports